import React, { useEffect, useState } from "react";
import "./Adminsummery.css";

const FinalSummary = () => {
  const [registration, setRegistration] = useState({});
  const [subscription, setSubscription] = useState({});
  const [termsAgreed, setTermsAgreed] = useState(false);

  useEffect(() => {
    // Load saved data from localStorage
    const reg = JSON.parse(localStorage.getItem("vendor_registration")) || {};
    setRegistration(reg);

    const plan = JSON.parse(localStorage.getItem("vendor_subscription")) || {};
    setSubscription(plan);

    const agreed = JSON.parse(localStorage.getItem("vendor_termsAgreed")) || false;
    setTermsAgreed(agreed);
  }, []);

  const handleConfirm = () => {
    alert("All data confirmed! Proceeding to next step.");
    // Next action: payment or final confirmation
  };

  return (
    <div className="final-page">
      <div className="final-header">
        <h1>FINAL SUMMARY</h1>
        <p>Review all your details before confirming</p>
      </div>

      {/* Registration Summary */}
      <div className="final-section">
        <h2>1. Registration Details</h2>
        <ul>
          <li><strong>Owner Name:</strong> {registration.ownerName || "-"}</li>
          <li><strong>Operation Type:</strong> {registration.operationType || "-"}</li>
          <li><strong>Company Name:</strong> {registration.companyName || "-"}</li>
          <li><strong>Business Plan:</strong> {registration.businessPlan || "-"}</li>
          <li><strong>Business Vertical:</strong> {registration.businessVertical || "-"}</li>
          <li><strong>Website:</strong> {registration.website || "-"}</li>
          <li><strong>Phone:</strong> {registration.phone || "-"}</li>
          <li><strong>Email:</strong> {registration.email || "-"}</li>
          <li><strong>Address:</strong> {registration.address || "-"}</li>
          <li><strong>Remarks:</strong> {registration.remarks || "-"}</li>
        </ul>
      </div>

      {/* Subscription Summary */}
      <div className="final-section">
        <h2>2. Subscription Plan</h2>
        <ul>
          <li><strong>Plan Selected:</strong> {subscription.plan || "-"}</li>
          <li><strong>Price:</strong> {subscription.price || "-"}</li>
          <li><strong>Start Date:</strong> {subscription.startDate || "-"}</li>
          <li><strong>End Date:</strong> {subscription.endDate || "-"}</li>
          <li><strong>Payment Method:</strong> {subscription.paymentMethod || "-"}</li>
        </ul>
      </div>

      {/* Terms & Conditions */}
      <div className="final-section">
        <h2>3. Terms & Conditions</h2>
        <p>{termsAgreed ? "Agreed ✅" : "Not Agreed ❌"}</p>
      </div>

      {/* Refund & Cancellation */}
      <div className="final-section">
        <h2>4. Refund & Cancellation Policy</h2>
        <ul>
          <li>Refund Eligibility: Within 7 days if service not used.</li>
          <li>Cancellation: Effective next billing cycle.</li>
          <li>Processing Time: 5-7 business days.</li>
          <li>Non-Refundable: Setup fees, late fees, services availed.</li>
        </ul>
      </div>

      {/* Confirm Button */}
      <div className="final-actions">
        <button onClick={handleConfirm}>CONFIRM & PROCEED</button>
      </div>
    </div>
  );
};

export default FinalSummary;
